import React from 'react';
import { PlayCircleIcon, ArrowRightIcon, ClockIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const sermons = [{
  title: 'Early Will I Seek Thee',
  date: 'Mon–Fri at 5:30 AM',
  duration: 'Live',
  image: 'https://images.unsplash.com/photo-1445445290350-18a3b86e0b5b?q=80&w=800&auto=format&fit=crop',
  featured: true
}, {
  title: 'Walking in Divine Authority',
  date: 'Recent Message',
  duration: '45:20',
  image: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?q=80&w=800&auto=format&fit=crop',
  featured: false
}, {
  title: 'The Power of Prophetic Declaration',
  date: 'Recent Message',
  duration: '52:10',
  image: 'https://images.unsplash.com/photo-1511649475669-e288648b2339?q=80&w=800&auto=format&fit=crop',
  featured: false
}];
export function SermonsSection() {
  return <section id="messages" className="py-24 md:py-32 bg-cream" data-id="element-259">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-260">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-261">
          <FadeIn data-id="element-262">
            <span className="text-gold font-semibold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-263">
              Watch & Listen
            </span>
            <h2 className="text-4xl md:text-5xl font-playfair font-bold text-charcoal" data-id="element-264">
              Messages
            </h2>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-265">
            <a href="#" className="inline-flex items-center gap-2 text-charcoal font-semibold hover:text-gold transition-colors group" data-id="element-266">
              View All Messages
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-267" />
            </a>
          </FadeIn>
        </div>

        <FadeIn className="mb-12" data-id="element-268">
          <div className="bg-charcoal rounded-sm p-8 md:p-12 flex flex-col md:flex-row items-center gap-8" data-id="element-269">
            <div className="w-20 h-20 bg-gold/20 rounded-full flex items-center justify-center shrink-0" data-id="element-270">
              <ClockIcon className="w-10 h-10 text-gold" data-id="element-271" />
            </div>
            <div className="text-center md:text-left" data-id="element-272">
              <span className="text-gold text-sm font-semibold tracking-wider uppercase" data-id="element-273">
                Daily Program
              </span>
              <h3 className="text-3xl md:text-4xl font-playfair font-bold text-white mt-2" data-id="element-274">
                Early Will I Seek Thee
              </h3>
              <p className="text-gray-400 font-inter mt-2" data-id="element-275">
                Join us every Monday through Friday at 5:30 AM for prayer and
                the Word.
              </p>
            </div>
            <a href="#" className="px-8 py-4 bg-gold hover:bg-goldLight text-dark font-semibold tracking-wide transition-all duration-300 rounded-sm shrink-0" data-id="element-276">
              Watch Now
            </a>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-277">
          {sermons.filter(s => !s.featured).map((sermon, index) => <FadeIn key={sermon.title} delay={index * 0.15} data-id="element-278">
                <a href="#" className="group block h-full" data-id="element-279">
                  <div className="relative aspect-video bg-charcoal rounded-sm overflow-hidden mb-6 shadow-lg group-hover:shadow-xl transition-shadow duration-300" data-id="element-280">
                    <img src={sermon.image} alt={sermon.title} className="w-full h-full object-cover opacity-80 group-hover:scale-105 group-hover:opacity-100 transition-all duration-700" data-id="element-281" />
                    <div className="absolute inset-0 bg-charcoal/40 group-hover:bg-charcoal/20 transition-colors duration-300 flex items-center justify-center" data-id="element-282">
                      <PlayCircleIcon className="w-16 h-16 text-gold opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300" data-id="element-283" />
                    </div>
                    <div className="absolute bottom-4 right-4 bg-dark/80 backdrop-blur-sm text-white text-xs font-semibold px-2 py-1 rounded" data-id="element-284">
                      {sermon.duration}
                    </div>
                  </div>
                  <div data-id="element-285">
                    <div className="text-gold text-sm font-medium mb-2" data-id="element-286">
                      {sermon.date}
                    </div>
                    <h3 className="text-2xl font-playfair font-bold text-charcoal group-hover:text-gold transition-colors leading-tight" data-id="element-287">
                      {sermon.title}
                    </h3>
                  </div>
                </a>
              </FadeIn>)}
        </div>
      </div>
    </section>;
}